import React from 'react'
import styled from 'styled-components'
import {connect} from 'react-redux'
import {injectIntl} from 'react-intl'
import moment from 'moment'
import Popover from '@mui/material/Popover'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import {KeyboardArrowDown} from '@mui/icons-material'
import DesktopHeader from 'containers/Header/Desktop'
import MobileHeader from 'containers/Header/Mobile'
import Sidebar from 'containers/Sidebar'
import Container from 'components/Container'
import PageNavigation from 'containers/PageNavigation'
import PlanningMenu from 'components/PlanningMenu'
import Dialog from 'components/Dialog'
import EventConfig from './EventConfig'
import Confirmation from 'components/Confirmation'
import PlanningFilter from 'components/PlanningFilter'
import {
    fetchScheduler,
    fetchSchedulerData,
    setSchedulerColors,
	deleteScheduler,
	resetScheduler,
    changeSchedulerEvent
} from 'modules/scheduler/actions'
import {resetModuleNotification} from 'modules/modules/actions'
import {isMobile} from 'utils/utils'
import operation from 'utils/enums/operation'
import route from 'utils/enums/route'
import Layout from './Layout'
import EventPopover from './EventPopover'

const options = {
    free: -1,
    reserved: -2
}

const consumerFilters = [
    {
        id: options.free,
        name: 'scheduler.show_free_slots',
        custom: true
    },
    {
        id: options.reserved,
        name: 'scheduler.show_reserved_slots',
        custom: true
    }
]

const Wrapper = styled.div`
     height: 100%;

    .fc-toolbar div:nth-child(3) {
		width: ${props => props.mobile ? 0 : props.toolbarWidth}px;
    }

	${props => props.mobile ? `
		.fc-toolbar div:nth-child(2) {
			position: fixed;
			top: 21px;
			z-index: 1111;
			left: 60px;

			h2 {
				font-size: 15px;
			}
		}
	` : ``}
`

const PopoverContent = styled.div`
    min-width: ${props => props.minWidth}px;
    margin: 18px;
`

const List = styled.div`
    margin: 20px 0;
`

const Title = styled.div`
    font-size: 13px;
    color: #a0b7be;
    letter-spacing: 0.3px;
`

const ControlView = styled(Select)`
    width: 100px;

    svg {
        font-size: 22px;
        color: #4a4a4a;
    }
`

const Toolbar = styled.div`
    position: absolute;
    right: 16px;
    top: 73px;
    height: 30px;
    display: flex;
`

const Week = styled.div`
    display: inline-flex;
    cursor: pointer;
    font-size: 13px;
    color: #a0b7be;
    letter-spacing: 0.3px;
`

const Event = styled.div`
	margin: 2px 2px 0;
	background-color: ${props => props.backgroundColor ? props.backgroundColor : '#415dd4'};
	border: 1px solid ${props => props.borderColor ? props.borderColor : '#415dd4'};
    color: ${props => props.textColor ? props.textColor : '#ffffff'};
	cursor: pointer;
	border-radius: 3px;
	font-size: 12px;
	padding: 1px;
`

const Time = styled.span`
	font-weight: bold;
	margin-right: 3px;
`

const views = {
    month: 'dayGridMonth',
    week: 'dayGridWeek',
    day: 'dayGridDay',
    list: 'listWeek'
}

class Scheduler extends React.Component {
    constructor(props) {
        super(props)

        this.calendarRef = React.createRef()

        this.allSegs = []
        this.eventsDate = null

        this.state = {
            open: null,
            id: null,
            date: null,
            owner: null,
            consumer: null,
            link: null,
            eventsDate: null,
            anchorEl: null
        }
    }

    componentDidMount() {
        this.props.fetchScheduler(Number(this.props.params.scheduler))
        this.props.fetchSchedulerData(Number(this.props.params.scheduler))
    }

    componentDidUpdate(props) {
        if (this.props.params.scheduler !== props.params.scheduler) {
            this.props.fetchScheduler(Number(this.props.params.scheduler))
            this.props.fetchSchedulerData(Number(this.props.params.scheduler))
        }

        if (this.props.params.view !== props.params.view) {
            const api = this.calendarRef.current.getApi()
            api.changeView(views[this.props.params.view], this.eventsDate)
            this.eventsDate = null
        }

		if (this.props.isUpdate) {
			this.props.fetchScheduler(Number(this.props.params.scheduler))
			this.props.resetModuleNotification()
		}

		if (!this.props.scheduler) {
            this.props.navigate('/')
        }
    }

	componentWillUnmount() {
		this.props.resetScheduler()
	}

    dateClick = (data) => {
        if (this.props.permissions.Write) {
            const now = moment()
            const date = moment(data.date)

            const datetime = date.set({
                'hour': now.get('hour'),
                'minute' : now.get('minute'),
                'second' : now.get('second')
            })

            this.setState({
                open: 'update',
                date: datetime.toISOString()
            })
        }
    }

    eventDrop = (eventDropInfo) => {
        const config = this.props.events.find(item => item.id === eventDropInfo.event.id)
        const data = {...config.data}
        const entity = this.props.entities.find(item => item.id === config.entityId)
        const dataset = this.props.scheduler.datasets.find(dataset => dataset.entityId === config.entityId)
        const fromField = entity.fields.find(field => field.id === dataset.start)
        const toField = entity.fields.find(field => field.id === dataset.end)

        data['c' + fromField.id] = eventDropInfo.event.start
        data['c' + toField.id] = eventDropInfo.event.end

        this.props.changeSchedulerEvent(config.entityId, data, this.props.scheduler.id, operation.update)
    }

    eventClick = (data) => {
        this.setState({
            anchorEl: data.el,
            id: data.event.id
        })
    }

    handleClose = () => {
        this.setState({
            anchorEl: null,
            id: null
        })
    }

    handleCloseDialog = () => {
        this.setState({
            open: null,
            date: null
        })
    }

    handleEditEvent = () => {
        this.setState({
            open: 'update'
        })
    }

    handleDeleteEvent = () => {
        this.setState({
            open: 'delete'
        })
    }

    handleDelete = () => {
        const data = this.props.events.find(item => item.id === this.state.id)
        this.props.changeSchedulerEvent(data.entityId, [data.recordId], this.props.scheduler.id, operation.delete)
        this.handleCloseDialog()
        this.handleClose()
        this.eventsListClose()
    }

    updateEvent = (entityId, data, id) => {
        this.props.changeSchedulerEvent(entityId, data, id, operation.update)
        this.handleCloseDialog()
        this.handleClose()
        this.eventsListClose()
    }

    createEvent = (entityId, data, id) => {
        this.props.changeSchedulerEvent(entityId, data, id, operation.create)
        this.handleCloseDialog()
    }

    setFilter = (id, property) => {
        if (property) {
            this.setState({
                [property]: id
            })
        } else {
            this.setState({
                owner: null,
                consumer: null
            })
        }
    }

    listEventClick = (id,anchorEl) => {
        this.setState({
            anchorEl,
            id
        })
    }

    eventLimitClick = (data) => {
		this.allSegs = [...data.allSegs]

        this.setState({
            eventsDate: data.date,
			link: data.jsEvent.currentTarget
        })

		return <div />
    }

    eventsListClose = () => {
        this.setState({
            eventsDate: null,
			link: null
        }, () => this.allSegs = [])
    }

    handleToWeek = () => {
        this.eventsDate = this.state.eventsDate
        this.eventsListClose()
        this.changeView(null, 'week')
    }

    changeView = (e, value) => {
        this.props.navigate(`/${route.Scheduler}/${this.props.scheduler.id}/${e ? e.target.value : value}`)
    }

    getLabel = (obj) => {
        if (this.state.owner && !this.state.consumer) {
            return obj.consumerName
        } else if (!this.state.owner && this.state.consumer) {
            return obj.ownerName
        } if (this.state.owner && this.state.consumer) {
            return obj.consumerName
        } else {
            return obj.ownerName + (obj.consumerName ? ' - ' + obj.consumerName : '')
        }
    }

    getColorId = (obj) => obj.ownerId

    getColor = (event, color) => {
        if (event.consumerId === '') {
            return {text: `rgb(${color})`, background: `rgba(${color}, 0.1)`, border: `rgb(${color})`}
        } else {
            return {text: '', background: `rgba(${color}, 0.7)`, border: `rgba(${color}, 0.7)`}
        }
    }

    popoverUpdate = (entity, data) => {
        this.props.changeSchedulerEvent(entity, data, this.props.scheduler.id, operation.update)
    }

    render() {
        const {intl, scheduler} = this.props

		if (!scheduler) return <div />

        const mobile = isMobile()
        const eventData = this.props.events.find(item => item.id === this.state.id)
        const entities = scheduler.datasets ?
            this.props.entities.filter(item =>
                scheduler.datasets.find(dataset => dataset.entityId === item.id)) : []
        const entity = entities.find(entity => entity.id === scheduler.datasets[0].entityId)
        const ownerField = entity ? entity.fields.find(field => field.id === scheduler.datasets[0].owner) : null
        const consumerField = entity ? entity.fields.find(field => field.id === scheduler.datasets[0].consumer) : null

        return (
            <React.Fragment>
                {mobile ?
                    <MobileHeader
                        height='60px'
                        logo={this.props.logo}
                    >
                        <span />
                    </MobileHeader>
                    :
                    <DesktopHeader padding={global.SIDE_BAR_SMALL_WIDTH} size='small'>
						{this.props.scheduler.id &&
							<PageNavigation
								id={this.props.scheduler.id}
								permissions={this.props.permissions}
                                type={route.Scheduler}
							/>
						}
                    </DesktopHeader>
                }
                {!mobile &&
                    <Sidebar size={global.SIDE_BAR_SMALL_WIDTH} logo={this.props.logo}>
                        <PlanningMenu
                            permissions={this.props.permissions}
                            data={this.props.scheduler}
                            colors={this.props.colors}
                            setColors={this.props.setSchedulerColors}
                            setFilter={this.setFilter}
							deletePlanning={this.props.deleteScheduler}
                            scheduler
                        />
                    </Sidebar>
                }
                <Toolbar>
                    {!mobile &&
                        <React.Fragment>
                            <PlanningFilter
                                filters={this.props.ownerFilters}
                                setFilter={this.setFilter}
                                filter={this.state.owner}
                                property='owner'
                                label={ownerField ? ownerField.singular : ''}
                            />
                            <PlanningFilter
                                filters={[...consumerFilters, ...this.props.consumerFilters]}
                                setFilter={this.setFilter}
                                filter={this.state.consumer}
                                property='consumer'
                                label={consumerField ? consumerField.singular : ''}
                            />
                        </React.Fragment>
                    }
                    <ControlView
                        value={this.props.params.view}
                        onChange={this.changeView}
                        IconComponent={KeyboardArrowDown}
						variant="standard"
                        MenuProps={{
                            anchorOrigin: {
                                vertical: 'top',
                                horizontal: 'left',
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left',
                            }
                        }}
                    >
                        {Object.keys(views).map(item =>
                            <MenuItem key={item} value={item}>
                                {intl.formatMessage({id: `planning.view_${item}`})}
                            </MenuItem>
                        )}
                    </ControlView>
                </Toolbar>
                <Container mobile={mobile} marginTop={60}>
                    <Wrapper
                        toolbarWidth={600}
                        mobile={mobile}
                    >
                        <Layout
                            events={this.props.events}
                            ownerFilter={this.state.owner}
                            consumerFilter={this.state.consumer}
                            colors={this.props.colors}
                            language={intl.locale}
                            dateClick={this.dateClick}
                            eventClick={this.eventClick}
                            eventDrop={this.eventDrop}
                            colorScheme={this.props.scheduler.colorScheme}
                            eventLimitClick={this.eventLimitClick}
                            ref={this.calendarRef}
                            defaultView={views[this.props.params.view]}
                            getLabel={this.getLabel}
                            getColorId={this.getColorId}
                            getColor={this.getColor}
                            options={options}
                        />
                    </Wrapper>
                </Container>
                <Dialog fullWidth={this.state.open === 'update' ? true : false}
                    open={!!this.state.open}
                    onClose={this.handleCloseDialog}
                >
                    {this.state.open === 'delete' ?
                        <Confirmation
                            text={intl.formatMessage({id: "planning.confirm_delete_record_text"}, {
                                name: entities.find(item => item.id === eventData.entityId).singular})}
                            handleClose={this.handleCloseDialog}
                            handleConfirm={this.handleDelete}
                        /> : this.state.open === 'update' ?
                        <EventConfig
                            date={this.state.date}
                            planning={this.props.scheduler}
                            handleClose={this.handleCloseDialog}
                            entities={entities}
                            config={eventData}
                            createEvent={this.createEvent}
                            updateEvent={this.updateEvent}
                        /> : <div />
                    }
                </Dialog>
                {eventData &&
                    <EventPopover
                        scheduler={this.props.scheduler.id}
                        anchorEl={this.state.anchorEl}
                        onClose={this.handleClose}
                        eventData={eventData}
                        permissions={this.props.permissions}
                        handleEdit={this.handleEditEvent}
                        handleDelete={this.handleDeleteEvent}
                        config={consumerField}
                        updateEvent={this.updateEvent}
                       
                    />
                }
                {this.state.eventsDate &&
                    <Popover
                        open={!!this.state.link}
                        anchorEl={this.state.link}
                        onClose={this.eventsListClose}
                        anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'right'
                        }}
                        transformOrigin={{
                            vertical: 'center',
                            horizontal: 'left'
                        }}
                    >
                        <PopoverContent minWidth='250'>
                            <Title>
                                {moment(this.state.eventsDate).format('dddd, MMMM D')}
                            </Title>
                            <List>
								{this.allSegs.map(item =>
									<Event
										key={item.event.id}
										onClick={(e) => this.listEventClick(item.event.id, e.target)}
										backgroundColor={item.event.backgroundColor}
                                        borderColor={item.event.borderColor}
                                        textColor={item.event.textColor}
									>
										<Time>{moment(item.event.start).format('HH:mm')}</Time>
										<span>{item.event.title}</span>
									</Event>	
								)}
							</List>
                            <Week onClick={this.handleToWeek}> go to week </Week>
                        </PopoverContent>
                    </Popover>
                }
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({entities, scheduler, applications, login, linkedfield, modules}) => ({
    entities: entities.entities,
    scheduler: scheduler.scheduler,
    events: scheduler.events,
    ownerFilters: scheduler.ownerFilters,
    consumerFilters: scheduler.consumerFilters,
    colors: scheduler.colors,
    logo: applications.logo,
    current: applications.current,
    permissions: login.permissions,
	isUpdate: modules.updatedCardSuccess
})

export default connect(mapStateToProps, {
    fetchScheduler,
    fetchSchedulerData,
    changeSchedulerEvent,
    setSchedulerColors,
	deleteScheduler,
	resetScheduler,
	resetModuleNotification
})(injectIntl(Scheduler))
